const indexItems = [
  { label: '浪漫恋爱', count: '256部', href: '#ranking' },
  { label: '奇幻冒险', count: '198部', href: '#carousel' },
  { label: '热血动作', count: '174部', href: '#carousel' },
  { label: '都市玄幻', count: '152部', href: '#cards' },
  { label: '悬疑惊悚', count: '118部', href: '#carousel' },
  { label: '异世界', count: '96部', href: '#cards' },
  { label: '校园青春', count: '85部', href: '#ranking' },
  { label: '古风历史', count: '67部', href: '#cards' },
];

const scrollTo = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">主题索引</h2>
          <p className="mt-3 text-sm text-foreground-600">按题材分类探索韩国漫画大全 · 快速定位心仪类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
              className="bg-background-50 rounded-lg p-5 flex flex-col items-center text-center cursor-pointer hover:bg-primary-50 transition-colors group"
            >
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-3 group-hover:bg-secondary-200 transition-colors">
                <i className="ri-bookmark-line text-lg text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">{item.label}</h3>
              <span className="text-xs text-foreground-500 mt-1">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}